// extracted by mini-css-extract-plugin
export default {"outer_container":"Rewards_outer_container__gAncL","conatiner":"Rewards_conatiner__vxDHs","reward_container":"Rewards_reward_container__NvNj-"};